import { render, staticRenderFns } from "./Zonas.vue?vue&type=template&id=e08fc0fe&"
import script from "./Zonas.vue?vue&type=script&lang=ts&"
export * from "./Zonas.vue?vue&type=script&lang=ts&"
import style0 from "./Zonas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e08fc0fe', component.options)
    } else {
      api.reload('e08fc0fe', component.options)
    }
    module.hot.accept("./Zonas.vue?vue&type=template&id=e08fc0fe&", function () {
      api.rerender('e08fc0fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/Zonas.vue"
export default component.exports